import { Box, List, ListItem, ListItemIcon, ListItemText, Grid, Typography, Alert, FormControl, TextField, FormHelperText, Snackbar, Button } from "@mui/material";
import { Contact } from "../../../types/Contact";
import { format } from 'date-fns';
import React, { useEffect, useState } from "react";

import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import PlaceIcon from '@mui/icons-material/Place';
import { sendContactMessage, fetchDefaultContactMessage } from "../../../services/connector";

function ContactTab({
    contact,
    onContactUpdate
}: {
    contact: Contact;
    onContactUpdate: (updatedContact: Contact) => void;
}) {
    const [message, setMessage] = useState("");
    const [snackOpen, setSnackOpen] = useState(false);

    useEffect(() => {
        const loadDefaultMessage = async () => {
            if (contact) {
                const defaultMessage = await fetchDefaultContactMessage(contact);

                setMessage(defaultMessage);
            } else {
                setMessage("");
            }
        }

        loadDefaultMessage();

        return () => {
            setMessage("");
        }
    }, [contact]);

    const handleSendMessage = async () => {
        if (contact) {
            const updatedContact = await sendContactMessage(contact, message);
            onContactUpdate(updatedContact);
            setSnackOpen(true);
        }
    }

    return (
        <Box sx={{ p: 2 }}>
            <List sx={{ display: "flex", flexDirection: "row", padding: 0 }}>
                <ListItem>
                    <ListItemIcon>
                        <PlaceIcon />
                    </ListItemIcon>
                    <ListItemText primary="Région" secondary={contact.coordinates.region || "Non renseigné"} />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <MailIcon />
                    </ListItemIcon>
                    <ListItemText primary="Email" secondary={contact.coordinates.email || "Non renseigné"} />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <PhoneIcon />
                    </ListItemIcon>
                    <ListItemText primary="Téléphone" secondary={contact.coordinates.phone || "Non renseigné"} />
                </ListItem>
            </List>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">Répondre au candidat</Typography>
                    <Typography variant="subtitle1">Ce module vous permet d'envoyer une instantanée au candidat, adaptez le texte selon la candidature si besoin.</Typography>
                    <Typography variant="subtitle2">Par respect pour les candidats, DOMemploi vous encourage à répondre à TOUTES les candidatures.</Typography>
                </Grid>
                <Grid item xs={12}>
                    {contact.responseDate ?
                        <Alert severity="success">Vous avez déjà répondu à ce candidat le {format(contact.responseDate, 'dd/MM/yyyy HH:mm')} UTC</Alert> :
                        <Alert severity="warning">Vous n'avez pas encore répondu à ce candidat.</Alert>
                    }
                </Grid>
                <Grid item xs={12}>
                    <FormControl variant="standard" fullWidth>
                        <TextField
                            label="Réponse au candidat"
                            multiline
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            minRows={10}
                        />
                        <FormHelperText id="component-helper-text">
                            1000 caractères max
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button onClick={handleSendMessage} variant="contained">Répondre au candidat</Button>
                </Grid>
            </Grid>
                    
            <Snackbar
                open={snackOpen}
                autoHideDuration={2500}
                onClose={() => setSnackOpen(false)}
                message="Nessage envoyé au candidat"
            />
        </Box >
    );
}

export default React.memo(ContactTab, (prevProps, nextProps) => {
    return prevProps.contact.id === nextProps.contact.id;
});
